/* eslint-disable no-unused-vars */
import { defaultClient as ApolloClient } from "../../../main";
import {
  GET_ALL_MEET_SESSION_EVENTS,
  GET_ALL_EVENTS
} from "../../../graphql/meetSessionEvent/meetSessionEventQ";
import {
  MEET_SESSION_EVENT_MERGE,
  MEET_SESSION_EVENT_DELETE
} from "../../../graphql/meetSessionEvent/meetSessionEventM";

export const actions = {
  allMeetEvent: async ({ commit }, payload) => {
    commit("setLoading", true);

    return ApolloClient.query({
      query: GET_ALL_MEET_SESSION_EVENTS,
      variables: payload
    })
      .then(({ data }) => {
        commit("setSessionEvent", data.allMeetEvent);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },
  addNewSessionEvent: async ({ dispatch, commit }, payload) => {
    return ApolloClient.mutate({
      mutation: MEET_SESSION_EVENT_MERGE,
      variables: payload,

      update: (cache, { data: { meetEventMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_MEET_SESSION_EVENTS
          });
          data.allMeetEvent.edges.push(meetEventMerge);
          // cache.writeQuery({
          //   query: GET_ALL_MEET_SESSION_EVENTS,
          //   data
          // });
        } catch (error) {
          console.error(
            `Error in addNewMeetEvent update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        // eslint-disable-next-line no-unused-vars
        const data = ApolloClient.query({
          query: GET_ALL_MEET_SESSION_EVENTS
        }).then(({ data: { allMeetEvent } }) => {
          commit("setSessionEvent", allMeetEvent);
        });
      })
      .catch(err => {
        console.error(`Error in addNewMeetEvent action. Full info: ${err}`);
      });
  },
  editCurrentSessionEvent: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: MEET_SESSION_EVENT_MERGE,
      variables: payload,
      // eslint-disable-next-line no-unused-vars
      update: (cache, { data: { meetSessionMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_MEET_SESSION_EVENTS
          });
          const currentMeetSession = data.allMeetSessions.edges.filter(
            session => +session.node.Id === +payload.Id
          );
          const sessionIndx = data.allMeetSessions.edges.indexOf(
            currentMeetSession[0]
          );
          //TODO Take this logic for all update actions
          if (sessionIndx !== -1) {
            // eslint-disable-next-line no-unused-vars
            for (let [key, value] of Object.entries(
              data.allMeetSessions.edges[sessionIndx].node
            )) {
              // eslint-disable-next-line no-unused-vars
              for (let [newKey, newValue] of Object.entries(payload)) {
                if (key === newKey) {
                  data.allMeetSessions.edges[sessionIndx].node[key] =
                    payload[newKey];
                }
              }
            }
          } else {
            console.error(
              "No index for update hook in editCurrentMeetSession action"
            );
          }
          cache.writeQuery({
            query: GET_ALL_MEET_SESSION_EVENTS,
            data
          });
        } catch (error) {
          console.error(
            `Error in update hook from editCurrentMeet action. Full info ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("setSessionEvent");
      })
      .catch(err => {
        console.error(
          `Error in editCurrentMeetSession action. Full info: ${err}`
        );
      });
  },
  deleteCurrentSessionEvent: async ({ dispatch, commit }, payload) => {
    return ApolloClient.mutate({
      mutation: MEET_SESSION_EVENT_DELETE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_ALL_MEET_SESSION_EVENTS
          });
          data.allMeetEvent.edges = data.allMeetEvent.edges.filter(
            event => +event.node.seqno !== +payload.seqno
          );
          commit("setSessionEvent", data.allMeetEvent);
        } catch (error) {
          console.error(
            `Error in deleteCurrentSessionEvent update hook. Full info: ${error}`
          );
        }
      }
    })
      .then(() => {
        // dispatch("setSessionEvent");
      })
      .catch(error => {
        console.error(
          `Error in deleteCurrentSessionEvent action. Full info: ${error}`
        );
      });
  },
  allEvents: async ({ commit }, payload) => {
    commit("setLoading", true);

    return ApolloClient.query({
      query: GET_ALL_EVENTS,
      variables: payload
    })
      .then(({ data }) => {
        commit("setEvent", data.allEvent);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  }
};
